<template>
  <div class="ch-container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/purchase' }">采购公告</el-breadcrumb-item>
      <el-breadcrumb-item>报名</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="ch-card">
      <div class="ch-enter-title">{{detail.projectName}}</div>
      <div class="ch-enter-time">报名截止时间：{{detail.signEndTime}}</div>
      <el-row :gutter="20">
        <el-col :span="20">
          <div class="ch-div-item">
            <div class="ch-enter-label">项目包件</div>
            <el-divider></el-divider>
            <el-table
                    :data="detail.packageInfoVos"
                    tooltip-effect="dark"
                    border
                    style="width: 100%;"
                    @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" width="55" />

              <el-table-column :show-overflow-tooltip="true" label="项目包件" prop="packageName" />
              <el-table-column label="价格" prop="packagePrice">
                <template slot-scope="scope">{{ scope.row.packagePrice}}元</template>
              </el-table-column>
            </el-table>
          </div>
          <div class="ch-div-item"  v-if="Checklist===1">
            <div class="ch-enter-label">资格预审清单</div>
            <el-divider>
            </el-divider>
            <div class="ch-desc">
              <div v-if="!preTrialChecklist[0].name">{{preTrialChecklist}}</div>
              <el-table :data="preTrialChecklist" v-if="preTrialChecklist[0].name" size="mini" border>
                <el-table-column label="资料名称" prop="name"></el-table-column>
                <el-table-column label="下载文件" prop="url">
                  <template slot-scope="scope">
                    <a class="download__url" v-if="scope.row.url" :href='scope.row.url' :download="scope.row.name">下载模板文件</a>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-upload
                    name="multipartFile"
                    action="/system/file/upload"
                    :on-success="uploadList"
                    multiple
                    :file-list="fileList">
              <el-button size="small" type="primary" style="margin-top: 10px">点击上传</el-button>
            </el-upload>
          </div>
          <div class="ch-div-item" v-if="Checklist===2" >
            <el-divider></el-divider>
            <div class="ch-pay-box">
              <div style="text-align: center;">
                <el-image :src="url" style="width:80px;height:80px" :preview-src-list="srcList"/>
                <div style="color: #343434;font-size: 14px;" >收款二维码</div>
              </div>
              <div class="ch-pay-item">
                <div class="ch-pay-item-price">报名费：{{price}}</div>
                <div class="ch-pay-item-desc">请用支付宝/微信扫描上方二维码进行支付，支付成功后请上传付款截图。</div>
                <div class="ch-pay-img">
                  <el-input placeholder="付款截图" clearable v-model="payFileName" disabled />
                  <el-upload
                    ref="payUpload"
                    name="multipartFile"
                    class="ch-upload-pay"
                    action="/system/file/upload"
                    :file-list="payFileList"
                    :on-success="onChange"
                  >
                    <el-button type="none"  plain>上传文件</el-button>
                  </el-upload>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="ch-info-buttons">
          <router-link to="/purchase/enter">
            <el-button type="primary" @click="submitDetail" class="el-button">{{buttonText}}</el-button>
          </router-link>
        </div>
    </el-card>
  </div>
</template>

<script>
  import announcement from "@/api/announcement/announcement"
export default {
    created(){
      this.projectId=sessionStorage.getItem("projectId");
      console.log(this.projectId);
      this.querySignUpInfo()
    },
  data() {

    return {
      project: [],
      fileList: [],
      payFileList: [],
      payFileName:'',
      projectId:"",
      detail:{  },
      price:0,
      Checklist:0,
      buttonText:"立即报名",
      url:"",
      submitData:{},
      srcList:[],
      preTrialChecklist:[]
    };
  },
  methods: {
      uploadList(req,file,fileList){
        console.log("???",fileList);
        this.submitData.preTrialChecklist=[];
        fileList.filter(item=>{
          console.log(item);
          this.submitData.preTrialChecklist.push({
            name:item.name,
            url:item.response.data
          })
        });
        console.log("????",this.submitData);
      },
    onChange(file,fileList){
      console.log("fileList",fileList);
      if (fileList.status==="success") {
        this.payFileList=[fileList];
        this.payFileName=fileList.name;
        this.submitData.signPaymentScreenshot=fileList.response.data;
      }else {
        this.$message.warning("上传失败，请稍后再试")
      }
    },
    handleSelectionChange(val) {
      // this.multipleSelection = val;
      this.price=0;
      this.submitData.packageInfoIds=val;
      val.filter(item=>{
        console.log(item);
        this.price+=item.packagePrice
      });
      console.log(this.price)
    },
    // 获取初始数据
    querySignUpInfo(){
      announcement.querySignUpInfo(
              {projectId:this.projectId}
      ).then(
              res=>{
                console.log("1111",res);
                this.detail=res.data;
                console.log(JSON.parse(res.data.preTrialChecklist))
                this.preTrialChecklist = JSON.parse(res.data.preTrialChecklist)
                this.url=this.detail.collectionCode;
                let list = []
                list.push(this.detail.collectionCode)
                this.srcList = list
                if (this.detail.signPreTrial===1){
                  this.Checklist=1;
                  this.buttonText="提交审批";
                }else if (this.detail.signPreTrial===2) {
                  this.Checklist=2;
                  this.buttonText="立即报名"
                }
              }
      )
    },
    // 提交数据
    submitDetail(){
        console.log("4687897",this.submitData.packageInfoIds!==undefined);

    // if (this.submitData.packageInfoIds!==undefined){

      console.log("????",this.submitData);

      if (this.submitData.packageInfoIds!==undefined) {
        this.submitData.projectId=sessionStorage.getItem("projectId");
        this.submitData.preTrialChecklist=JSON.stringify(this.submitData.preTrialChecklist);
        this.submitData.packageInfoIds.filter(item=>{
          console.log(item);
          item.packageId=item.id
        });
        if (this.Checklist === 2) {
          console.log("报名",this.submitData);
          if (this.submitData.signPaymentScreenshot!==undefined && this.submitData.signPaymentScreenshot && this.submitData.signPaymentScreenshot.length !== 0) {
            announcement.signUp(this.submitData).then(
                    res => {
                      console.log(res);
                      if (res.code === 200) {
                        this.$message.success(res.msg);
                        this.$router.push({path: "/user/project"})
                      }
                    }
            )
          } else {
            this.$message.warning("请上传付款截图")
          }
        }
        else if (this.Checklist === 1) {
          if (this.submitData.preTrialChecklist!==undefined) {
            announcement.datPreExamination(this.submitData).then(
                    res => {
                      console.log(res);
                      if (res.code === 200) {
                        this.$message.success(res.msg);
                        this.$router.push({path: "/user/project"})
                      }
                    }
            )
          } else {
            this.$message.warning("请上传文件")
          }
        }
      }else {
        this.$message.warning("请选择包件")
      }

  },
},
    };
</script>

<style lang="less" scoped>
.ch-card {
  margin-top: 20px;
  border-top: 2px solid #3a84f7;
  padding: 40px;
}
.ch-enter-title {
  font-size: 24px;
  color: #343434;
}
.ch-enter-time {
  margin-top: 15px;
  font-size: 14px;
  color: #9a9a9a;
}
.ch-enter-label {
  color: #343434;
  font-size: 16px;
  font-weight: bold;
}
.ch-div-item {
  margin-top: 30px;
  .el-divider {
    margin-top: 15px;
    margin-bottom: 20px;
  }
  .ch-desc {
    font-size: 14px;
    color: #666666;
  }
}
/deep/ .el-table .cell {
  text-align: center;
}
.ch-upload {
  margin-top: 20px;
}
.ch-pay-box {
  display: flex;
}
.ch-pay-item {
  margin-left: 20px;
  .ch-pay-item-price {
    font-size: 18px;
    font-weight: bold;
    color: #343434;
  }
  .ch-pay-item-desc {
    font-size: 14px;
    font-weight: 300;
    color: #343434;
  }
}
.ch-upload-pay {
    
  display: flex;
  /deep/ .el-upload-list {
    display: none;
  }
}
.ch-pay-img {
    margin-top: 20px;
  display: flex;
}
.ch-info-buttons {
  margin-top: 35px;
  text-align: center;
  .el-button {
    padding-left: 40px;
    padding-right: 40px;
  }
}
.download__url{
  cursor: pointer;
  text-decoration: underline;
}
</style>